import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, buildError, API } from '../../api/apis';
import { ApiResponse, DescribeNetworkMonitoringRequest, DescribeNetworkMonitoringResponse, UpdateNetworkMonitoringRequest } from '../../interfaces/interfaces';

// Define the RTK Query service for networkmonitoring
export const networkmonitoringService = createApi({
  reducerPath: 'networkmonitoringApi',
  tagTypes: ['NetworkMonitoring'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getNetworkMonitoring: builder.query({
      query: (request: DescribeNetworkMonitoringRequest) => {
        const result = API.FETCH_NETWORK_MONITORING(request);
        return result || ''; // Ensure a valid string is returned
      },
      providesTags: () => [{ type: 'NetworkMonitoring', id: 'DESCRIBE' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as DescribeNetworkMonitoringResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    updateNetworkMonitoring: builder.mutation({
      query: (request: UpdateNetworkMonitoringRequest) => ({
        url: API.UPDATE_NETWORK_MONITORING(request),
        method: 'PUT',
        body: {EnableNetworkMonitoring: request.EnableNetworkMonitoring},
        params: { region: request.Region },
      }),
      invalidatesTags: [{ type: 'NetworkMonitoring', id: 'DESCRIBE' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as DescribeNetworkMonitoringResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetNetworkMonitoringQuery, useLazyGetNetworkMonitoringQuery, useUpdateNetworkMonitoringMutation } = networkmonitoringService;
